import config from './config'
import _ from 'lodash'
import MemberInfo from '../global/js/memberinfo'

let _params = {};

let initKey =function(){
	let m=MemberInfo.getMemberInfo();
	if(!_.isEmpty(m)){
		config.authparams.key = m.key;
	}
}

//获取登录权限
initKey()

class ZJF {
	//获取已授权列表
	location (param) {
		_.map(config.authparams, function (value,key) { param += '&'+key+'='+value; });
		param += '&vuetype=1';
        window.location.href = param;
	}
}
export default ZJF;


// WEBPACK FOOTER //
// ./src/api/ZJF.js